export const JEWELLERY_UNDER_80_COLLECTION = {
  path: "/products/collections/jewellery-under-80",
  maxPrice: 80,
  initialCurrencyCode: "GBP",
  supportedCurrencyCodes: ["USD", "GBP", "EUR"],
  currencySymbols: {
    USD: "$",
    GBP: "£",
    EUR: "€",
  },
} as const;

export type PriceCollectionCurrency =
  (typeof JEWELLERY_UNDER_80_COLLECTION.supportedCurrencyCodes)[number];

export function normalizeCurrencyCode(currencyCode?: string): string {
  return currencyCode?.trim().toUpperCase() ?? "";
}

export function isPriceCollectionCurrency(
  currencyCode?: string,
): currencyCode is PriceCollectionCurrency {
  const normalized = normalizeCurrencyCode(currencyCode);
  return JEWELLERY_UNDER_80_COLLECTION.supportedCurrencyCodes.includes(
    normalized as PriceCollectionCurrency,
  );
}

export function getPriceCollectionCurrencySymbol(currencyCode?: string): string {
  const normalized = normalizeCurrencyCode(currencyCode);
  return isPriceCollectionCurrency(normalized)
    ? JEWELLERY_UNDER_80_COLLECTION.currencySymbols[normalized]
    : "";
}
